var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"118","height":"111","rx":"55.5","fill":"#FF5100","key":0}),React.createElement("path",{"d":"M48.5996 37.793V75.4763L78.7885 56.6346L48.5996 37.793Z","fill":"white","key":1})]);
}

Play.defaultProps = {"width":"118","height":"111","viewBox":"0 0 118 111","fill":"none"};

module.exports = Play;

Play.default = Play;
